import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";

import App from "./containers/App/index";
import registerServiceWorker from './registerServiceWorker';
// Add this import:
import { AppContainer } from 'react-hot-loader';

//Context
import Context from './context';
import { ViewportState } from './context/Viewport/viewportContext';

import "assets/vendors/style";
import 'bootstrap/dist/css/bootstrap.css';

// Wrap the rendering in a function:
const render = Component => {
  console.log("Desde_index_main_render")
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <ViewportState>
        <Context>
          <BrowserRouter>
            <Switch>
              <Route path="/" component={Component} />
            </Switch>
          </BrowserRouter>
        </Context>
      </ViewportState>
    </AppContainer>,
    document.getElementById('root')
  );
};

// Do this once
registerServiceWorker();

// Render once
render(App);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./containers/App/index', () => {
    render(App);
  });
}
